import { motion } from 'framer-motion';

export const GallerySection = () => {
  // All before/after images displayed together
  const projects = [
    {
      id: 1,
      before: '/images/before-after/67056024_965169220320354_4063234053531238400_n.jpg',
      after: '/images/before-after/67450035_969032316600711_2605234390460006400_n.jpg',
      title: 'Residential Driveway',
      location: 'Worcester, MA'
    },
    {
      id: 2,
      before: '/images/before-after/68531865_978491125654830_1580280001918402560_n.jpg',
      after: '/images/before-after/68928636_989709781199631_7717616336066576384_n.jpg',
      title: 'Driveway Restoration',
      location: 'Shrewsbury, MA'
    },
    {
      id: 3,
      before: '/images/before-after/69223991_989709774532965_6835992032758988800_n.jpg',
      after: '/images/before-after/164350655_1442047005965904_6816503185569627024_n.jpg',
      title: 'Commercial Parking',
      location: 'Auburn, MA'
    },
    {
      id: 4,
      before: '/images/before-after/166254467_1445925765578028_9020803406534033123_n.jpg',
      after: '/images/before-after/480394809_1134364452034262_5025839827719400019_n.jpg',
      title: 'Full Sealcoating',
      location: 'Grafton, MA'
    },
    {
      id: 5,
      before: '/images/before-after/480646628_1137289805075060_8266697805778703971_n.jpg',
      after: '/images/before-after/485618525_1163558765781497_1396921168371327921_n.jpg',
      title: 'Crack Repair',
      location: 'Millbury, MA'
    },
    {
      id: 6,
      before: '/images/before-after/486238137_1163281419142565_8389867529308611919_n.jpg',
      after: '/images/before-after/494206830_1197675389036501_2124445691920368093_n.jpg',
      title: 'Parking Lot Service',
      location: 'Worcester, MA'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-neutral-950 relative">
      {/* Rhino watermark background - decorative */}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] pointer-events-none overflow-hidden" aria-hidden="true">
        <img 
          src="/images/logo.jpg" 
          alt="" 
          role="presentation"
          className="w-[800px] h-[800px] object-contain"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="flex items-center justify-center gap-4 mb-4">
            <img src="/images/logo.jpg" alt="Rhino Seal" className="w-16 h-16 rounded-full border-2 border-red-600" />
          </div>
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider">
            Our Work
          </span>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mt-4 mb-6">
            BEFORE &
            <span className="text-red-500"> AFTER</span>
          </h2>
          <p className="text-xl text-neutral-400 max-w-3xl mx-auto">
            See the dramatic transformation our professional sealcoating brings to driveways and parking lots.
          </p>
        </motion.div>

        {/* Gallery grid - No filters, all photos shown */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group"
            >
              {/* Before/After side by side in one card */}
              <motion.div 
                className="bg-neutral-900 border-2 border-neutral-800 rounded-sm overflow-hidden"
                whileHover={{ 
                  scale: 1.03, 
                  borderColor: '#dc2626',
                  boxShadow: '0 0 30px rgba(220, 38, 38, 0.3)'
                }}
                transition={{ duration: 0.3 }}
              >
                {/* Images container */}
                <div className="grid grid-cols-2 gap-1">
                  {/* Before image */}
                  <div className="relative overflow-hidden">
                    <img
                      src={project.before}
                      alt={`${project.title} - Before`}
                      className="w-full h-52 object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  
                  {/* After image */}
                  <div className="relative overflow-hidden">
                    <img
                      src={project.after}
                      alt={`${project.title} - After`}
                      className="w-full h-52 object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>

        {/* Bottom rhino badge */}
        <motion.div 
          className="mt-16 flex justify-center"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <div className="flex items-center gap-4 bg-gradient-to-r from-red-600 to-red-700 px-8 py-4 rounded-sm">
            <img src="/images/logo.jpg" alt="Rhino Seal" className="w-14 h-14 rounded-full border-2 border-white" />
            <div>
              <p className="text-white font-black text-xl uppercase">Rhino Strong Results</p>
              <p className="text-white/80 text-sm">Every project backed by our quality guarantee</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default GallerySection;
